export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref5613.8c85a8e7.jpg";